export default function usePermissionsComposable(
    permission: string | string[],
    permissions: any[],
    isAgent: boolean = false
): boolean {
    if (isAgent) return true;

    // Si es un array de permisos, todos deben estar presentes
    if (Array.isArray(permission)) {
        return permission.every(perm => usePermissionsComposable(perm, permissions, isAgent));
    }

    return permissions?.some((p: any) => {
        // Verificar si el permiso actual coincide por action o entity
        // Si action es null, usar entity como fallback
        const matchesByAction = p.action === permission && p.enabled;
        const matchesByEntity = p.action === null && p.entity === permission && p.enabled;
        const matches = matchesByAction || matchesByEntity;

        if (matches) {
            return true;
        }

        // Buscar recursivamente en children
        if (p?.children != null && p.children.length > 0) {
            const result = p.children.some((c: any) => {
                const childMatchesByAction = c.action === permission && c.enabled;
                const childMatchesByEntity = c.action === null && c.entity === permission && c.enabled;
                return childMatchesByAction || childMatchesByEntity;
            });
            return result;
        }

        return false;
    }) || false;
}